import { Component } from '@theme/component';

class MtFacets extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.abort?.abort();
    this.abort = new AbortController();
    this.root = this.closest('results-list');
    if (!this.root) return;
    this.hidden = false;
    this.rebuild();
    this.addEventListener('change', () => this.apply(), { signal: this.abort.signal });
    this.querySelector('[data-reset]').addEventListener('click', () => { this.querySelectorAll('select').forEach(select => { select.value = ''; }); this.apply(); }, { signal: this.abort.signal });
    this.observer = new MutationObserver(records => {
      if (records.some(record => !this.contains(record.target))) this.rebuild();
    });
    this.observer.observe(this.root, { childList: true, subtree: true });
  }
  normalize(value) { return (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  rebuild() {
    this.cards = [...this.root.querySelectorAll('[data-mt-title]')];
    const groups = { style: ['minimaliste', 'squelette', 'sport'], material: ['cuir', 'acier', 'silicone', 'ceramique'], movement: ['quartz', 'automatique', 'mecanique'], color: ['noir', 'blanc', 'bleu', 'vert', 'dore', 'argent', 'rose'], diameter: ['small', 'medium', 'large'] };
    const labels = this.querySelector('template').content;
    for (const select of this.querySelectorAll('select')) {
      const selected = select.value;
      while (select.options.length > 1) select.remove(1);
      for (const key of groups[select.dataset.facet]) {
        if (!this.cards.some(card => this.matches(card, select.dataset.facet, key))) continue;
        const option = document.createElement('option');
        option.value = key; option.textContent = labels.querySelector(`[data-key="${key}"]`).textContent;
        select.append(option);
      }
      select.value = selected;
      select.closest('label').hidden = select.options.length < 2;
    }
    this.apply();
  }
  matches(card, kind, value) {
    if (!value) return true;
    if (kind === 'style') return this.normalize(card.dataset.mtTitle).includes(value);
    if (kind === 'diameter') {
      const text = this.normalize(card.dataset.mtDiameter);
      const match = text.match(/(?:diametre\s*:?\s*)?(\d+(?:[.,]\d+)?)\s*(mm|cm)/);
      if (!match) return false;
      let size = Number(match[1].replace(',', '.')) * (match[2] === 'cm' ? 10 : 1);
      if (size < 20 || size > 65) return false;
      return value === 'small' ? size < 36 : value === 'medium' ? size >= 36 && size <= 40 : size > 40;
    }
    const key = `mt${kind[0].toUpperCase()}${kind.slice(1)}`;
    return this.normalize(card.dataset[key]).includes(value);
  }
  apply() {
    let count = 0;
    const selections = [...this.querySelectorAll('select')];
    for (const card of this.cards) {
      card.hidden = !selections.every(select => this.matches(card, select.dataset.facet, select.value));
      if (!card.hidden) count++;
    }
    this.querySelector('[data-facet-count]').textContent = this.dataset.count.replace('[count]', String(count));
    this.querySelector('[data-facet-empty]').hidden = count !== 0;
  }
  disconnectedCallback() { super.disconnectedCallback(); this.abort?.abort(); this.observer?.disconnect(); }
}
if (!customElements.get('mt-facets')) customElements.define('mt-facets', MtFacets);
